module.exports = __webpack_public_path__ + "img/moon.daf2f7b2.svg";